<div class="test-container">
    <div>Test inside test component 123</div>

    {{ testFunction() }}

    <audio-trimmer></audio-trimmer>
</div>
